import { AllEnrolledProductLines } from './EnrolledProductLines';
import { AllProductLines } from './ProductLines';
export const AllCombinedProductLines = [...AllProductLines, ...AllEnrolledProductLines];